;(function (_, $) {
  $(document).ready(function() {
    const dropdowns = $('.naviti-language-dropdown');
    const triggers = $('.naviti-language-switcher button');

    triggers.on('click', function() {
      const dropdown = $(this).next('.naviti-language-dropdown');
      const isHidden = dropdown.hasClass('nvi:hidden');
      
      dropdowns.addClass('nvi:hidden');
      triggers.attr('aria-expanded', 'false');
      
      if (isHidden) {
        dropdown.removeClass('nvi:hidden');
        $(this).attr('aria-expanded', 'true');
      }
    });

    $(document).on('click', function(event) {
      if (!$(event.target).closest('.naviti-language-switcher').length) {
        dropdowns.addClass('nvi:hidden');
        triggers.attr('aria-expanded', 'false');
      }
    });
  });
})(window, jQuery);
